<template>
    <div :class="theme.wrapper">
        <div :class="theme.layout">
            <div v-if="config.show_row_count" :class="theme.numberOfRows">
                <div v-if="pagingHidden" :class="theme.grandTotal">
                    <span>{{ totalRows }}</span> rows
                </div>
                <div v-else :class="theme.pageTotal">
                    <span>{{ startRow }}</span>
                    -
                    <span>{{ endRow }}</span>
                    of
                    <span>{{ totalRows }}</span>
                </div>
            </div>

            <div v-show="!pagingHidden">
                <button
                    type="button"
                    class="btn btn-default"
                    :class="theme.first"
                    title="First Page"
                    @click="first"
                >
                    <i class="fa-solid fa-chevron-double-left" />
                </button>
                <button
                    type="button"
                    class="btn btn-default"
                    :class="theme.previous"
                    title="Previous Page"
                    @click="previous"
                >
                    <i class="fa-solid fa-chevron-left" />
                </button>

                <div :class="theme.page">
                    Page:
                    <input
                        ref="pageInput"
                        v-select-on-focus
                        type="text"
                        :class="theme.current"
                        :value="props.page_num"
                        @change="pageNumChanged"
                        @keypress.enter="pageNumChanged"
                        @keyup="keyup"
                    />
                    of
                    <span :class="theme.total">{{ totalPages }}</span>
                </div>

                <button
                    type="button"
                    class="btn btn-default"
                    :class="theme.next"
                    title="Next Page"
                    @click="next"
                >
                    <i class="fa-solid fa-chevron-right" />
                </button>
                <button
                    type="button"
                    class="btn btn-default"
                    :class="theme.last"
                    title="Last Page"
                    @click="last"
                >
                    <i class="fa-solid fa-chevron-double-right" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Common from './mixins/Common.vue';

export default {
    mixins: [Common],
    props: {
        data: Object,
    },
    computed: {
        startRow() {
            return Number(
                (this.props.page_num - 1) * this.props.page_size_actual + 1,
            );
        },
        endRow() {
            const endRow = this.startRow + this.props.page_size_actual - 1;
            if (endRow > this.totalRows) {
                return this.totalRows;
            } else {
                return endRow;
            }
        },
        pagingHidden() {
            return this.props.page_size === 'all' || this.isEmpty;
        },
        totalPages() {
            if (this.pagingHidden) {
                return 1;
            } else {
                return Math.ceil(this.totalRows / this.props.page_size_actual);
            }
        },
    },
    mounted() {
        this.autosizePageInput();
    },
    methods: {
        keyup() {
            const input = this.$refs.pageInput;
            input.value = input.value.replace(/\D/g, '');
            this.autosizePageInput();
        },
        autosizePageInput() {
            const input = this.$refs.pageInput;
            input.style.width = 9 + input.value.length * 8 + 'px';
        },
        pageNumChanged() {
            const input = this.$refs.pageInput;
            if (input.value >= 1 && input.value <= this.totalPages) {
                this.setPage(event.srcElement.value);
            } else {
                input.value = this.props.page_num;
            }
        },
        setPage(num) {
            num = Number(num);
            if (
                num === this.props.page_num ||
                num < 1 ||
                num > this.totalPages
            ) {
                return;
            }

            this.bus.$emit('set-page', num);
        },
        next() {
            this.setPage(this.props.page_num + 1);
        },
        last() {
            this.setPage(this.totalPages);
        },
        first() {
            this.setPage(1);
        },
        previous() {
            this.setPage(this.props.page_num - 1);
        },
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/page_control.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/page_control.scss"
></style>
